import { render, staticRenderFns } from "./TopPensionFundsView.vue?vue&type=template&id=c975fbc2&scoped=true"
import script from "./TopPensionFundsView.vue?vue&type=script&lang=js"
export * from "./TopPensionFundsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c975fbc2",
  null
  
)

export default component.exports